/*
 * File: CommentFeed.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 2, 2025 at 12:09 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	padding: 25px 0px 15px;
`;

export const LoaderContainer = styled.div`
	width: 100%;
	height: 60px;
	position: relative;
	margin-top: -10px;
`;

export const Threads = styled.div``;

export const ThreadContainer = styled.div`
	margin: 15px 0px 0px;
	padding-left: ${({ $depth }) => $depth * 20}px;
`;
